<template>
  <div>
    <div class="gdpr-window">
      <div class="bg-white rounded p-12 m-1 sm:my-12 sm:mx-auto max-w-2xl">
        <Main
          v-if="!areSettingsVisible"
          :data="data"
          @write="write"
          @openSettings="areSettingsVisible = true"
        />

        <Settings v-if="areSettingsVisible" :options="options" :data="data" @write="write" />
      </div>
    </div>
  </div>
</template>

<script>
import Turbolinks from 'turbolinks';
import axios from 'axios';
import trim from 'lodash/trim';
import Main from './main';
import Settings from './settings';

const QUERY_PARAM = 'cookie_settings=1';

export default {
  components: { Main, Settings },

  props: {
    data: Object,
    options: Array
  },

  data() {
    return {
      areSettingsVisible: document.location.search.indexOf(QUERY_PARAM) > -1
    };
  },

  methods: {
    async write(data) {
      await axios({
        url: '/cookies',
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: { settings: data }
      });

      // It is better to "reload" the page with Turbolinks,
      // so Matomo can have the correct referrer
      let { pathname, search } = document.location;
      search = search.replace(QUERY_PARAM, '');

      if(!search.includes('utm')) {
        search = trim(search, '?');
      }

      Turbolinks.visit(`${pathname}${search}`);
    },

    _(key) {
      return this.data[key];
    }
  }
};
</script>
<style scoped>
.gdpr-window {
  @apply fixed inset-0 bg-black bg-opacity-60 overflow-auto;

  z-index: 1000;
}
</style>